document.addEventListener('DOMContentLoaded', function () {
  const mapElement = document.getElementById('contactor-location-map');
  const loadMapButton = document.getElementById('load-map-button');

  if(!mapElement || !loadMapButton) {
    return;
  }

  let map; // Declare map variable here for scope
  let marker; // Declare marker variable here for scope

  loadMapButton.addEventListener('click', function () {
    $('.chat-container').addClass('d-none');
    $('.note-container').addClass('d-none');

    if ( mapElement.style.display == 'block') {
      mapElement.style.display = 'none';
      return
    }


    // Show the map container
    mapElement.style.display = 'block';

    const latitude = mapElement.dataset.latitude;
    const longitude = mapElement.dataset.longitude;

    // Check if map is already initialized
    if (!map) {
      // Initialize the map
      map = L.map('contactor-location-map').setView([0, 0], 10); // Default center

      // Add a tile layer (you can use OpenStreetMap or other providers)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
      }).addTo(map);

      if (longitude && latitude) {
          map.setView([latitude, longitude], 16); // Center the map on the contractor's location

          // Add a marker for the contractor's location
          marker = L.marker([latitude, longitude])
            .addTo(map)
            .bindPopup('Contractor location')
            .openPopup();
      } else {
        alert('Contractor location not found.');
      }
    } else {
      if (longitude && latitude) {
        marker.setLatLng([latitude, longitude])
          .bindPopup('Contractor location')
          .openPopup();
        map.setView([latitude, longitude], 16);
      } else {
        alert('Contractor location not found.');
      }
    }
  });
});